export const checkStatusForm = (duration) => {
   switch (duration) {
      case 'approve':
         return 'อนุมัติ';
      case 'draft':
         return 'แบบร่าง';
      case 'pending':
         return 'รออนุมัติ';
      case 'cancel':
         return 'ยกเลิก';
      case 'reject':
         return 'ไม่อนุมัติ';
   }
}

const loopCheckArray = (data) =>{
   let formData = new FormData();

   for ( var key in data ) {
      console.log('data[key]', data[key])
      if(key == 'approver'){
         formData.append(key, JSON.stringify(data[key]))
      }else{
         formData.append(key, data[key])
      }
   }

   console.log('formData', formData.getAll('empCode'))
   return formData
   // return formData
}

export const appendFormData = async(data) => {
   console.log('duration', data)
   let formData = null
   formData = loopCheckArray(data)
   console.log('xcvavxformData', formData.getAll("approver"))
   // for ( var key in data ) {
   //    if(key == 'approver'){
   //       // console.log('eeeekey', key)
   //       // console.log('eeeedata[key]', data[key])
   //       // formData.append(key, data[key])
        
   //       // await Promise.all(
   //          // await data[key].map(async(valuesArray)=>{
   //          //    console.log('JSON.stringify(valuesArray)', JSON.stringify(valuesArray))
   //          //    formData.append(key, JSON.stringify(valuesArray));
   //          // })
   //       // )
   //    }else{
   //       formData.append(key, data[key]);
   //    }
   // }
   // let test = formData.entries()

   // return formData.entries()
}

 
export const sumTotalAbstainDate = (data) => {
    console.log("sumTotalAbstainDate data",data)
    return data.reduce((accumulator, object) => 
    {
       return accumulator + object.abstainDays;
    }, 0); 
 }
